import React, { useEffect, useRef, useState } from "react"
import { Link } from "@reach/router"
import Isvg from 'react-inlinesvg'
import _ from "lodash"
import { navigate } from '@reach/router'
// PR
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import { ContextMenu } from "primereact/contextmenu"
// Components
import CarouselAutomation from "components/carousel-automation"
import { field as _field } from "components/table/lib/column-field"
import { Toolbar } from "components/subnav"
import SearchHeader from "components/table/search-header"
import {
  TableAutomation,
  focusFirstCellByRowIndex,
  focusCellByContent,
  pageToFirst,
  getPagingInfo,
  getFocusedRowIndex,
  unfocusAllCells } from "components/table/table-automation"
import { TextEdit, DropdownEdit } from "components/table/inputs"
import { InputText_s } from "styles/input-styles"
import { DropdownField } from "components/table/display"
import Controls from "components/asset-management/chart/controls/"
import { Errors } from "components/asset-management/errors"
import Import from "components/import-export/import"
import { WithTip } from 'components/tooltip/with-tip'
// Data
import automationService from "data/automation"
import detailAccountService from "data/detailaccount"
import summaryAccountService from "data/summaryaccount"
import chartService, { Chart } from "data/chart"
import importService from "data/import"
import keyService, * as chord from "data/key"
import { handleReferences } from "data/lib/handle-references"
import validationService from "data/validate"
import { copy, paste, canPaste, getPasteInfo } from "data/lib/copy-paste"
import toggles from "feature-toggles"
// Styles
import { ChartChildTable_s } from "components/asset-management/chart/chart-styles"
import { Breadcrumb_s } from "components/asset-management/chart/chart-styles"
import { HeaderIcon_s } from "components/wrapper/header/header-styles"
import { CaretRightIcon, BackArrowIcon } from 'images/icons/general/'
import { AddIcon } from "images/icons/tools"
import { DetailedRouteUpDown_s, DetailedUpDownBtn_s } from "components/table/data-table-styles"
// Icons
import { CaretDownIcon, CaretUpIcon } from "images/icons/tools/"
import ExportIcon from "components/import-export/export-icon"
import ImportIcon from "components/import-export/import-icon"

type ContextRow = {
  detailaccountid: number
  accountnumber: string
  sortorder?: number
  systeminput?: string
}

const tableId = "detailAccountsTable"

type PropTypes = {
  path: string // from route
  chartId?: string // from route
}

const DetailAccounts = (props: PropTypes) => {
  const [showSelected, setShowSelected] = useState<boolean>(false)
  const [selected, setSelected] = useState<ContextRow[]>([]);
  const chartId = parseInt(props.chartId!)

  const usePrevious = (value) =>{
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  }

  const nonSystemMenu = [
    {label: 'Copy Cell', icon: 'pi pi-fw pi-copy', command: e => { if(contextRow.systeminput === "systemImmutable") return;
      copy(contextCell, contextRow)
    }},
    {label: selected.length ? 'Delete Rows' : 'Delete Row', icon: 'pi pi-fw pi-trash', command: e => { if(contextRow.systeminput) return;
      const pager         = getPagingInfo(tableId);
      const currentRowNum = getFocusedRowIndex() + 1
      const currentRecordIndex = (pager.currentPage > 1 ? (pager.currentPage - 1) * pager.pageSize : 0) + currentRowNum - 1
      showDeleteConfirmation(contextRow, currentRecordIndex + 1)
    }},
    {label: 'Trace', icon: 'pi pi-fw pi-search', command: e => {
      const refreshFn = () => detailAccountService.fetchDetailAccounts(chartId)
      handleReferences('detailaccount', contextRow.detailaccountid, {refreshFn});
    }},
  ]

  const [charts, setCharts] = useState<Chart[]|null>(null);
  const [currentChart, setCurrentChart] = useState<Chart|null>(null);
  const [details, setDetails] = useState<object[]|null>([]);
  const [summaries, setSummaries] = useState<object[]|null>([]);
  const [filteredData, setFilteredData] = useState<any[]>([]);
  const [searchFilter, setSearchFilter] = useState<string>("")
  const [contextRow, setContextRow] = useState<ContextRow>({detailaccountid: 0, accountnumber: ''})
  const [contextCell, setContextCell] = useState<object|null>(null)
  const [deleteConfirmation, setDeleteConfirmation] = useState<JSX.Element | null>(null)
  const prevSearch = usePrevious(searchFilter);
  const [automationActive, setAutomationActive] = useState<boolean>(false);
  const [tableAutomationActive, setTableAutomationActive] = useState<boolean>(true);
  const [summaryAccountOptions, setSummaryAccountOptions] = useState<[]>([])
  const [summaryAccountFilter, setSummaryAccountFilter] = useState<string>("");
  const [accountnumberFilter, setAccountnumberFilter] = useState<string>("");
  const [descriptionFilter, setDescriptionFilter] = useState<string>("");
  const [statusFilter, setStatusFilter] = useState<string>("All");
  const [showImport, toggleShowImport] = useState<boolean>(false)
  const [menu, setMenu] = useState<[]|object[]>(nonSystemMenu)
  const [_errors, setErrors] = useState<any>()
  const menuRef = useRef<ContextMenu | null>(null)
  const tableRef = useRef() as React.MutableRefObject<DataTable>
  const field = _field('detailaccount')
  const statusOptions = [{value: 'Active', label: 'Active'},{value: 'Inactive', label: 'Inactive'}]
  // these two could be factored out since detail-account doesn't have contain/table component split, but keeping the multiselect changes the same between files for now.
  const [deleteFlag, setDeleteFlag] = useState(0)
  const [pasteFlag, setPasteFlag] = useState(0)

  const chartid = currentChart?.chartid
  useEffect(() => {
    if(!chartid) return
    validationService.validateByParent('detailaccount', 'chart', chartid)
  },[chartid])

  useEffect(() => {
    if (prevSearch !== "" && searchFilter === "") _.invoke(tableRef, 'current.filter', '', 'contains');
    else if (searchFilter !== "") _.invoke(tableRef, 'current.filter', searchFilter, 'contains');
    else return
  }, [searchFilter])

  useEffect(() => {
    setTableAutomationActive(true)
    setAutomationActive(false)
  }, [currentChart])

  useEffect(() => {
    setMenu(nonSystemMenu)
  }, [contextRow])

  useEffect(() => {
    const chartSubscription = chartService.stream().subscribe((data) => {
      if (data.state === "ok"){
        setCharts(data.value)
        setCurrentChart(_.find(data.value, {chartid: chartId}))
      }
    })

    const detailAccountSubscription = detailAccountService.stream().subscribe((data) => {
      if (data.state === "ok"){
        setDetails(data.value)
      }
    })

    const summaryAccountSubscription = summaryAccountService.stream().subscribe((data) => {
      if (data.state === "ok"){
        let options = _.map(data.value, (sum) => {
          return {label: `${sum.accountnumber} - ${sum.description}`, value: sum.summaryaccountid}
        })
        setSummaries(data.value)
        setSummaryAccountOptions(options)
      }
    })

    const detailAccountEventSubscription = detailAccountService.eventStream().subscribe(e => {
      switch(true) {
        case e.type === "DETAILACCOUNT_CREATED":
          setTimeout(() => pageToFirst(tableId), 1)
          setTimeout(() => {
            focusFirstCellByRowIndex(tableId, 0)
          }, 500)
          break
        case e.type === "DETAILACCOUNT_COPIED":
          setTimeout(() => {
            focusCellByContent(tableId, e.payload.code)
          }, 500)
      }
    })

    const keySubscription = keyService.stream().subscribe(k => {
      switch(true) {
        case k.chord === chord.CTRL_SHIFT_PLUS && k.down === true:
          if(!window[`${tableId}_carousel_in_focus`]) {
            unfocusAllCells()
            detailAccountService.create(chartId)
          }
          break
        case k.chord === chord.CTRL_SHIFT_MINUS && k.down === true:
          if(!window[`${tableId}_carousel_in_focus`]) {
            const pager         = getPagingInfo(tableId);
            const currentRowNum = getFocusedRowIndex() + 1
            const currentRecordIndex = (pager.currentPage > 1 ? (pager.currentPage - 1) * pager.pageSize : 0) + currentRowNum - 1
            const records       = tableRef.current.props.value!;
            const currentRow    = records[currentRecordIndex];
            if (!currentRow.systeminput) showDeleteConfirmation(currentRow, currentRecordIndex + 1)
          }
          break
      }
    })

    importService.stream().subscribe(data => {
      toggleShowImport(data['showImport'])
    })

    const validationSubscription = validationService.stream().subscribe((e) => {
      setErrors(e)
    })

    chartService.fetchCharts()
    detailAccountService.fetchDetailAccounts(chartId)
    summaryAccountService.fetchSummaryAccounts(chartId)

    return function cleanup() {
      chartSubscription.unsubscribe()
      detailAccountSubscription.unsubscribe()
      detailAccountEventSubscription.unsubscribe()
      summaryAccountSubscription.unsubscribe()
      keySubscription.unsubscribe()
      validationSubscription.unsubscribe()
    }
  }, [])

  useEffect(() => {
    const filter = (errors) => {
      if (!currentChart) return errors
      const chartid = _.get(currentChart, 'chartid')
      if (!chartid) return errors
      let { chart, cashflowmap, detailaccount, summaryaccount } = _.cloneDeep(_.pick(errors.errordetail, 'chart', 'summaryaccount', 'cashflowmap', 'detailaccount'))

      if (chart) chart = {[chartid]: chart[chartid] || []}

      for (let table of [cashflowmap, detailaccount, summaryaccount]) {
        for (let id in (table||{})){
          if (table[id][0]['_object'].chartid !== chartid) {
            delete table[id]
          }
        }
      }

      return {
        ...errors,
        errordetail: {chart, cashflowmap, detailaccount, summaryaccount},
        calcDetail: undefined
      }
    }
    validationService.addFilter(filter)
    return () => validationService.removeFilter(filter)
  }, [currentChart])

  useEffect(() => {
    const keySubscription = keyService.stream().subscribe(k => {
      switch(true) {
        case k.chord === chord.CTRL_SHIFT_UP && k.down === true:
          toggleChart('up')
          break
        case k.chord === chord.CTRL_SHIFT_DOWN && k.down === true:
          toggleChart('down')
          break
        case k.chord === chord.CTRL_SHIFT_BACK && k.down === true:
          navigate('/n/asset-management/chart')
      }
    })

    return function cleanup() {
      keySubscription.unsubscribe()
    }
  })

  useEffect(() => {
    filterData();
  }, [details, summaryAccountFilter, accountnumberFilter, descriptionFilter, statusFilter])

  const persist = (value, field, rowData) => {
    const detailAccount = _.cloneDeep(rowData)
    _.set(detailAccount, field, value)
    detailAccountService.patch(detailAccount)
  }

  const refresh = async () => {
    const detailaccounts = await detailAccountService.fetchDetailAccounts(chartId)
    setSelected(_.intersectionBy(detailaccounts, selected, 'detailaccountid'))
  }

  useEffect(() => {
    if(canPaste(contextCell, selected)) {
      nonSystemMenu.splice(1, 0, {label: selected.length ? 'Paste to Rows' : 'Paste Cell', icon: 'pi pi-fw pi-file', command: e => {
        if (selected.length > 1) {
          showPasteConfirmation(contextRow, -1)
          return
        }
        paste(contextCell, contextRow, refresh, 'detailaccount', selected)
      }})
    }
    contextRow.systeminput === "systemImmutable" ? setMenu([]) : setMenu(nonSystemMenu)
  }, [contextCell, selected.length])

  useEffect(() => {
    if (!deleteFlag) return //skip first time
    showDeleteConfirmation(_.first(selected), -1)
  }, [deleteFlag])

  function showDeleteConfirmation(record: ContextRow, currentRow: number) {
    automationService.broadcast("MODAL_OPENING", {})
    setDeleteConfirmation(Controls.ChartChildDeleteConfirmation({
      show: true,
      message: `Would you like to delete the ${selected.length} selected rows? Note this cannot be undone.`,
      close: () => {
        setDeleteConfirmation(null)
        setTimeout(() => automationService.broadcast("MODAL_CLOSING", {}), 200)
      },
      confirm: () => {
        if (selected.length > 1) {
          detailAccountService.deleteMultiple(chartId, _.map(selected, 'detailaccountid'))
        } else {
          detailAccountService.deleteOne(chartId, record.detailaccountid)
        }
        setDeleteConfirmation(null)
        setTimeout(() => {
          focusFirstCellByRowIndex(tableId, currentRow - 2 > 0 ? currentRow - 2 : 0)
        }, 200)
      },
      rowNum: currentRow,
      accountnumber: record.accountnumber,
      selected
    }))
  }

  useEffect(() => {
    if (!pasteFlag) return //skip first time
    if (!canPaste(contextCell, selected)) return
    showPasteConfirmation(contextRow, -1)
  }, [pasteFlag])

  const showPasteConfirmation = (record: ContextRow, currentRow: number) => {
    automationService.broadcast("MODAL_OPENING", {})
    setDeleteConfirmation(Controls.ChartChildDeleteConfirmation({
      show: true,
      title: 'Paste',
      message: `Would you like to paste ${getPasteInfo()._meta.field} data to the ${selected.length} selected rows? Note this cannot be undone.`,
      close: () => {
        setDeleteConfirmation(null)
        setTimeout(() => automationService.broadcast("MODAL_CLOSING", {}), 200)
      },
      confirm: () => {
        paste(contextCell, contextRow, refresh, 'detailaccount', selected)
        setDeleteConfirmation(null)
        setTimeout(() => {
          focusFirstCellByRowIndex(tableId, currentRow - 2 > 0 ? currentRow - 2 : 0)
        }, 200)
      },
      rowNum: currentRow,
      accountnumber: record.accountnumber,
      selected
    }))
  }

  function toggleChart(direction:string):void {
    const currentChartIdx       = charts?.indexOf(currentChart!);
    let   nextChart:Chart|null  = null
    if (direction === 'up' && charts){
      nextChart = charts && charts[currentChartIdx! - 1]
    } else {
      nextChart = charts && charts[currentChartIdx! + 1]
    }
    if (nextChart) setCurrentChart(nextChart)
    nextChart && detailAccountService.fetchDetailAccounts(nextChart['chartid'])
  }

  function updateContextMenu(originalEvent){
    if (!menu.length){
      setMenu(nonSystemMenu)
    }
    _.invoke(menuRef.current, "show", originalEvent)
  }

  function filterData():void {
    let nextData = _.cloneDeep(details);

    if(summaryAccountFilter !== "") nextData = nextData.filter(item => {
      let sumid = _.get(item, 'summaryaccountid')
      let sum = _.find(summaries, (s) => s.summaryaccountid === sumid)
      return _.get(sum, "accountnumber")?.toLowerCase().includes(summaryAccountFilter.toLowerCase()) || _.get(sum, "description")?.toLowerCase().includes(summaryAccountFilter.toLowerCase())
    })
    if(accountnumberFilter !== "") nextData = nextData.filter(item => _.get(item, 'accountnumber')?.toLowerCase().includes(accountnumberFilter.toLowerCase()))
    if(descriptionFilter !== "") nextData = nextData.filter(item => _.get(item, 'description')?.toLowerCase().includes(descriptionFilter.toLowerCase()))
    if(statusFilter !== "All") nextData = nextData.filter(item => _.get(item, 'status') && _.find(statusOptions, { value: _.get(item, 'status')})['label'].toLowerCase().includes(statusFilter.toLowerCase()))

    setFilteredData(nextData)
  }

  const rowClassName = (rowData) => {
    return {'' : rowData}
  }

  const Add = () => {
    return (
      <a onClick={() => detailAccountService.create(chartId)}>
        <Isvg src={AddIcon} width="20px" />
      </a>
    )
  }

  const Delete = () => {
    return (
      <WithTip position="bottom">
        <span>Delete Selected Rows</span>
        <a className={selected.length && !_.some(selected, 'systeminput')  ? '' : 'disabled'}
          onClick={() => {
            if (!selected.length || _.some(selected, 'systeminput')) return
            setDeleteFlag(deleteFlag+1)
        }}>
          <span className="p-menuitem-icon pi pi-fw pi-trash"></span>
        </a>
      </WithTip>
    )
  }

  const Paste = () => {
    return (
      <WithTip position="bottom">
        <span>Paste to Selected Rows</span>
        <a className={selected.length && !_.some(selected, 'systeminput') ? '' : 'disabled'}
          onClick={() => {
            if (!selected.length || _.some(selected, 'systeminput')) return
            setPasteFlag(pasteFlag+1)
          }
        }>
          <span className="p-menuitem-icon pi pi-fw pi-clone"></span>
        </a>
      </WithTip>
    )
  }

  const ShowSelected = () => (
    <WithTip position="bottom">
      <span>Show {showSelected ? 'All' : 'Selected'} Rows</span>
      <a className={selected.length ? '' : 'disabled'}
        onClick={() => {
          if (!selected.length) return
          setShowSelected(!showSelected)
        }}>
        <span className={showSelected ? 'pi pi-eye-slash' : 'pi pi-eye'} style={{height: '18px', width: '18px'}}></span>
      </a>
    </WithTip>
  )

  useEffect(() => {
    setSelected(_.intersectionBy(filteredData, selected, 'detailaccountid'))
  }, [filteredData])

  const _data = showSelected ? selected : filteredData

  return (
    <div>
      <Toolbar>
        <Add />&nbsp;&nbsp;
        <ImportIcon info={{chartid: _.get(currentChart, 'chartid')}} />
        {currentChart && <ExportIcon template="detailaccount" chartid={_.get(currentChart, 'chartid')} /> }
        {toggles.multiselect() && <>
          <Paste />
          <Delete />
          <ShowSelected />
        </>}
        {currentChart &&
          <Breadcrumb_s>
            <Link to="/n/asset-management/chart">
              <HeaderIcon_s style={{marginRight: '5px'}}><Isvg src={BackArrowIcon} /></HeaderIcon_s>
              Chart
            </Link>
            <HeaderIcon_s style={{marginRight: '5px'}}><Isvg src={CaretRightIcon} /></HeaderIcon_s>
            <div>Detail Accounts</div>
            <DetailedRouteUpDown_s>
              <DetailedUpDownBtn_s id="detailedRouteRecordUp" disabled={!charts || _.isNil(charts[charts.indexOf(currentChart!) - 1])} onClick={()=>toggleChart('up')}><Isvg src={CaretUpIcon} /></DetailedUpDownBtn_s>
              <DetailedUpDownBtn_s id="detailedRouteRecordDown" disabled={!charts || _.isNil(charts[charts.indexOf(currentChart!) + 1])} onClick={()=>toggleChart('down')}><Isvg src={CaretDownIcon} /></DetailedUpDownBtn_s>
            </DetailedRouteUpDown_s>
            <div>{_.get(currentChart, "code")}</div>
          </Breadcrumb_s>
        }
        <Errors />
      </Toolbar>
      <SearchHeader setSearchFilter={setSearchFilter} />
      <ContextMenu model={menu} ref={menuRef} appendTo={document.querySelector("body")} onHide={() => {}}/>
      { showImport ? <Import /> :
      <ChartChildTable_s id="detail-accounts-table-scrollable-container">
        <DataTable
          globalFilter={searchFilter}
          id={tableId}
          ref={tableRef}
          value={_data}
          paginator={true}
          rows={20}
          rowsPerPageOptions={[10, 20, 50, 100, 500]}
          scrollable={true}
          frozenWidth={toggles.multiselect() ? "45px" : void 0}
          paginatorPosition="bottom"
          rowClassName={rowClassName}
          stateStorage="custom"
          onContextMenu={e => menuRef.current ? updateContextMenu(e.originalEvent) : null}
          contextMenuSelection={contextRow}
          onContextMenuSelectionChange={e => {
            setSelected([])
            setContextRow(e.value)
            setContextCell(e.originalEvent.target)
          }}
          customSaveState={state => localStorage.setItem("primereact-table-preferences", JSON.stringify({rows: state.rows}))}
          customRestoreState={() => JSON.parse(localStorage.getItem("primereact-table-preferences")!)}
          selection={selected} onSelectionChange={(e) => {
            const selected = _.filter(e.value, (it) => it.systeminput !== "systemImmutable")
            setSelected(selected)
          }}
        >
          {toggles.multiselect() && <Column selectionMode="multiple" frozen={true} style={{minWidth: "45px", paddingLeft: "8px"}}/>}
          <Column style={{minWidth: "325px"}} className="p-editable-column"
            filter
            sortable
            header="Summary Account#"
            {...field('summaryaccountid', (rowData, props) => DropdownField({options: summaryAccountOptions, rowData, ...props}))}
            editor={props => <DropdownEdit options={summaryAccountOptions} default="" persist={persist} {...props} />}
            filterElement={
              <InputText_s value={summaryAccountFilter} onChange={(e) => setSummaryAccountFilter(e.target.value)} />
            }
          />
          <Column style={{minWidth: "200px"}} className="p-editable-column"
            filter
            sortable
            header="Account#"
            {...field('accountnumber')}
            editor={props => TextEdit({persist, ...props})}
            filterElement={
              <InputText_s value={accountnumberFilter} onChange={(e) => setAccountnumberFilter(e.target.value)} />
            }
          />
          <Column style={{minWidth: "325px"}} className="p-editable-column"
            filter
            sortable
            header="Description"
            {...field('description')}
            editor={props => TextEdit({persist, ...props})}
            filterElement={
              <InputText_s value={descriptionFilter} onChange={(e) => setDescriptionFilter(e.target.value)} />
            }
          />
          <Column style={{minWidth: "100px"}} className="p-editable-column"
            filter
            sortable
            header="Status"
            {...field('status', (rowData, props) => DropdownField({options: statusOptions, rowData, ...props}))}
            editor={props => <DropdownEdit options={statusOptions} default="" persist={persist} {...props} />}
            filterElement={
              <DropdownEdit
                field="statusFilter"
                rowData={{statusFilter}}
                options={[{value:"All", label:"All"}, ...statusOptions]}
                persist={(val) => setStatusFilter(val)}
              />
            }
          />
        </DataTable>
        { deleteConfirmation }
        { filteredData && filteredData.length
          ? <div>
              <CarouselAutomation outsideTable={true} automationActive={automationActive} editableFilters={true} includeSearchBar={true} tabOut={() => { setAutomationActive(false); setTableAutomationActive(true) }}/>
              <TableAutomation tableId={tableId} automationActive={tableAutomationActive} shiftTabOut={() => setTableAutomationActive(false)}/>
            </div>
          : null
        }
        <span className="selection-count">{ selected.length ? `Selected Rows: ${selected.length}`: null}</span>
      </ChartChildTable_s>}
    </div>
  )
}

export default DetailAccounts
